import { IntegrationCardView } from './vendor-definition.model';

/**
 * Per-partner presentation of a guided partner (REV-21656), keyed by the
 * stable appKey (the §6 vendor identity). Everything else on the card and in
 * the modal is generic or comes from the registered client (displayName), so
 * a NEW partner works with zero front-end changes — an entry here only adds
 * its logo and partner-specific wording.
 */
export type PartnerBranding = Pick<IntegrationCardView, 'logoSrc' | 'bannerBgColor'> & {
    /** Partner-specific card text; falls back to the generic card description. */
    descriptionKey?: string;
    /** Partner-specific info-modal text; falls back to the generic modal text. */
    modalTextKey?: string;
};

const PARTNER_BRANDING: Record<string, PartnerBranding> = {
    aprivo: {
        logoSrc: '/assets/hamIcons/aprivo-logo.svg',
        bannerBgColor: '#eef2ff',
        descriptionKey: 'aumico_partner_connect_card_description_aprivo',
        modalTextKey: 'aumico_partner_connect_modal_text_aprivo',
    },
};

/** Partners without a branding entry get the neutral partner mark. */
const DEFAULT_PARTNER_BRANDING: PartnerBranding = {
    logoSrc: '/assets/hamIcons/partner-app-logo.svg',
    bannerBgColor: '#f0fdfa',
};

export function partnerBrandingFor(appKey: string | null | undefined): PartnerBranding {
    return (appKey != null ? PARTNER_BRANDING[appKey] : undefined) ?? DEFAULT_PARTNER_BRANDING;
}
